import DigitalClock from './DigitalClock';
import AnalogClock from './AnalogClock';
import RomanAnalogClock from './RomanAnalogClock';
import MinimalClock from './MinimalClock';
import FlipClock from './FlipClock';
import WordClock from './WordClock';
import SegmentClock from './SegmentClock';

export const CLOCK_REGISTRY = {
  digital: { label: 'Digital', component: DigitalClock },
  analog: { label: 'Analog', component: AnalogClock },
  roman: { label: 'Roman Analog', component: RomanAnalogClock },
  minimal: { label: 'Minimal', component: MinimalClock },
  flip: { label: 'Flip Clock', component: FlipClock },
  word: { label: 'Word Clock', component: WordClock },
  segment: { label: 'LED Segment', component: SegmentClock },
};

export const CLOCK_KEYS = Object.keys(CLOCK_REGISTRY);

export function getClock(key) {
  return CLOCK_REGISTRY[key] || CLOCK_REGISTRY.digital;
}
